import { Skeleton as SkeletonAntd } from 'antd';
import React from 'react';

const AVATAR_OPTIONS = { size: 50 };
const PARAGRAPH_OPTIONS = { rows: 4 };

export const Skeleton = (): JSX.Element => {
    return (
        <div tw="grid grid-row-gap[32px]">
            <SkeletonAntd
                loading={true}
                active
                title={false}
                avatar={AVATAR_OPTIONS}
                paragraph={PARAGRAPH_OPTIONS}
            ></SkeletonAntd>
            <SkeletonAntd
                loading={true}
                active
                title={false}
                avatar={AVATAR_OPTIONS}
                paragraph={PARAGRAPH_OPTIONS}
            ></SkeletonAntd>
            <SkeletonAntd
                loading={true}
                active
                title={false}
                avatar={AVATAR_OPTIONS}
                paragraph={PARAGRAPH_OPTIONS}
            ></SkeletonAntd>
            <SkeletonAntd
                loading={true}
                active
                title={false}
                avatar={AVATAR_OPTIONS}
                paragraph={PARAGRAPH_OPTIONS}
            ></SkeletonAntd>
            <SkeletonAntd
                loading={true}
                active
                title={false}
                avatar={AVATAR_OPTIONS}
                paragraph={PARAGRAPH_OPTIONS}
            ></SkeletonAntd>
        </div>
    );
};
